export default __webpack_public_path__ + "media/zurb/img/development-process/package-6522c54c05f5281590cb4d0be5b7d830.png";